import { Grid, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { CheckboxInput, TextInput } from './Inputs';
import FormattedMessages from '../../../../messages/admin/CustomerProfileMessages';

const SenderInfo = ({ profile, highlighted, onChange }) => {
  const [sender, setSender] = useState({});
  const [noFields, setNoFields] = useState(false);

  useEffect(() => {
    const sender = { ...profile?.sender } || {};
    setSender(sender);
    setNoFields(Object.values(sender).every((field) => !field.visible));
  }, [profile]);

  const handleInputChange = (name, value) => {
    const s = { ...sender };
    s[name].value = value;
    setSender(s);
    onChange('sender', s);
  };

  return (
    <Grid container spacing={10} sx={{ width: '100%' }}>
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          {noFields && (
            <Typography variant="body1" color="text.secondary">
              {FormattedMessages.noFields}
            </Typography>
          )}

          {/* Use Sender ID */}
          {sender.uses_sender_id?.visible && (
            <CheckboxInput
              id="uses_sender_id"
              name="uses_sender_id"
              label={FormattedMessages.useSenderId}
              checked={!!sender.uses_sender_id?.value}
              onChange={handleInputChange}
              required={sender.uses_sender_id?.required}
              highlighted={highlighted}
            />
          )}

          {/* Sender ID */}
          {sender.sender_id_value?.visible && (
            <TextInput
              id="sender_id_value"
              name="sender_id_value"
              label={FormattedMessages.senderId}
              value={sender.sender_id_value?.value}
              onChange={handleInputChange}
              required={sender.sender_id_value?.required}
              highlighted={highlighted}
            />
          )}

          {/* Sender ID relationship to Brand */}
          {sender.sender_id_relationship?.visible && (
            <TextInput
              id="sender_id_relationship"
              name="sender_id_relationship"
              label={FormattedMessages.senderBrandRelationship}
              value={sender.sender_id_relationship?.value}
              onChange={handleInputChange}
              required={sender.sender_id_relationship?.required}
              highlighted={highlighted}
            />
          )}

          {/* Message Sample */}
          {sender.sender_id_sample?.visible && (
            <TextInput
              id="sender_id_sample"
              name="sender_id_sample"
              label={FormattedMessages.messageSample}
              value={sender.sender_id_sample?.value}
              onChange={handleInputChange}
              required={sender.sender_id_sample?.required}
              highlighted={highlighted}
            />
          )}

          {/* Comments */}
          {sender.sender_comments?.visible && (
            <TextInput
              id="sender_comments"
              name="sender_comments"
              multiline
              rows={3}
              label={FormattedMessages.senderComments}
              value={sender.sender_comments?.value}
              onChange={handleInputChange}
              required={sender.sender_comments?.required}
              highlighted={highlighted}
            />
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default SenderInfo;
